import styled from "styled-components";

export const SectionBody = styled.div`
  padding: 10px 20px;
  height: calc(100vh - 18rem);
`;
